import type { ProductDetailProduct } from '@grandvisionhq/fun-products'
import type { DeliveryResolver } from '@grandvisionhq/shipping'
import { defaultDeliveryResolver } from '@grandvisionhq/shipping'

type DeliveryResolverFactory = (
  products?: ProductDetailProduct[],
  productType?: string,
  stockStatus?: 'in-stock' | 'out-of-stock' | undefined
) => DeliveryResolver

export const deliveryResolverFactory: DeliveryResolverFactory = (products, type, stockStatus) => {
  return (config, availability) => {
    if (!Array.isArray(products) || type !== 'Contact-lenses' || !stockStatus) {
      return defaultDeliveryResolver(config, availability)
    }

    return stockStatus === 'in-stock' ? ['1 a 2'] : ['5 a 7']
  }
}
